module.exports = __webpack_public_path__ + "static/flags/DJ-bc4c9d2e6bb70d434d78c7d230c5dba2.gif";